/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CashbackRatesContainer_brand$ref: FragmentReference;
declare export opaque type CashbackRatesContainer_brand$fragmentType: CashbackRatesContainer_brand$ref;
export type CashbackRatesContainer_brand = {|
  +id: string,
  +name: string,
  +defaultCashbackRates: $ReadOnlyArray<{|
    +startDate: any,
    +endDate: any,
    +rate: number,
    +state: string,
  |}>,
  +birthdayCashbackRates: $ReadOnlyArray<{|
    +startDate: any,
    +endDate: any,
    +rate: number,
    +state: string,
  |}>,
  +$refType: CashbackRatesContainer_brand$ref,
|};
export type CashbackRatesContainer_brand$data = CashbackRatesContainer_brand;
export type CashbackRatesContainer_brand$key = {
  +$data?: CashbackRatesContainer_brand$data,
  +$fragmentRefs: CashbackRatesContainer_brand$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "afterDate",
    "variableName": "afterDate"
  },
  {
    "kind": "Variable",
    "name": "beforeDate",
    "variableName": "beforeDate"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "state",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDate",
      "type": "Date!"
    },
    {
      "kind": "RootArgument",
      "name": "beforeDate",
      "type": "Date!"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CashbackRatesContainer_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "CashbackRate",
      "kind": "LinkedField",
      "name": "defaultCashbackRates",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "CashbackRate",
      "kind": "LinkedField",
      "name": "birthdayCashbackRates",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Store"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd676f88edfc0e43d533ae7fa547f6917';

module.exports = node;
